var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',_vm._g(_vm._b({directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],style:(_vm.style),attrs:{"color":"transparent"}},'v-sheet',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }